export enum SaleFactorType {
  TaminElectronicPrescription = 0,

  FreePrescription = 1,

  Prescription = 2,

  OTC = 3,

  SalamatElectronicPrescription = 4,
}
